const shluchimTableColumnMap = (eventFeesPaid: boolean = false) => [
  { name: "Shliach", size: "1fr", isRelevant: () => true },
  { name: "Shlucha", size: "1fr", isRelevant: () => true },
  { name: "Chabad House", size: "1fr", isRelevant: () => true },
  { name: "Campus", size: "1fr", isRelevant: () => true },
  {
    name: "# of Shluchim + Chaperones",
    size: "1fr",
    isRelevant: (isTravelTrip, _) => !isTravelTrip,
  },
  { name: "Students Accepted", size: "0.5fr", isRelevant: () => true },
  {
    name: "Capacity",
    size: "0.5fr",
    isRelevant: (_isTravelTrip, defaultChabadHouseCapacity) =>
      !!defaultChabadHouseCapacity,
  },
  {
    name: "Venue",
    size: "1fr",
    isRelevant: (isTravelTrip, _defaultChabadHouseCapacity, hasVenues) =>
      !isTravelTrip && !!hasVenues,
  },
  {
    name: `COCI Owe${eventFeesPaid ? "d" : "s"}`,
    size: "0.5fr",
    isRelevant: (isTravelTrip) => !isTravelTrip,
  },
  {
    name: `Shliach Owe${eventFeesPaid ? "d" : "s"}`,
    size: "0.5fr",
    isRelevant: (isTravelTrip) => !isTravelTrip,
  },
  { name: "Actions", size: "1fr", isRelevant: () => true },
];

export function getShluchimTableColumns(
  isTravelTrip: boolean,
  defaultChabadHouseCapacity: number | null,
  eventFeesPaid: boolean,
  hasVenues: boolean = false,
) {
  return shluchimTableColumnMap(eventFeesPaid).filter((col) =>
    col.isRelevant(isTravelTrip, defaultChabadHouseCapacity, hasVenues),
  );
}
